import React, { useState } from "react";
import "../../styles/pages/Tasks/task.css";
import { Award, ChevronDown, MoveUpRight, Sparkles, Plus, Trash2, Upload, UploadIcon, PencilLine , Eye } from "lucide-react";
import ReusableTable from "../../components/Common/TaskReusableTable";
import TaskDrawer from "../../components/Task/TaskDrawer";
import { FiMoreHorizontal } from "react-icons/fi";
import AiChat from "../../components/Common/AiChat";

const Tasks = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [tasks, setTasks] = useState([
      { name: "Task 1", sop: "Strategy", status: "Pending", dueDate: "Jun 27, 2023", priority: "High", assignee: "Alice", name2: "Customers" },
      { name: "Task 2", sop: "SEO", status: "In Progress", dueDate: "Jun 27, 2023", priority: "Medium", assignee: "Bob", name2: "Content" },
      { name: "Task 3", sop: "SEO", status: "Completed", dueDate: "Jun 27, 2023", priority: "Low", assignee: "Charlie", name2: "Onpage" },
      { name: "Task 4", sop: "ADS", status: "Completed", dueDate: "Jun 27, 2023", priority: "Low", assignee: "John", name2: "Image Gallery" },
    ]);

  const [selectedRow, setSelectedRow] = useState(null);

  const handleSearch = (value) => {
    console.log('Searching:', value);
  };

  const handleDelete = (ids) => {
    setTasks(tasks.filter(task => !ids.includes(task.name)));
  };

  const handleDuplicate = (ids) => {
    const duplicatedTasks = tasks
      .filter(task => ids.includes(task.name))
      .map(task => ({
        ...task,
        name: `${task.name} (Copy)`,
      }));
    setTasks([...tasks, ...duplicatedTasks]);
  };

  const handleMenuOption = (action, rowData) => {
    console.log(`${action} clicked for`, rowData);
    setSelectedRow(null);
  };

  const columns = [
    {
      id: "selection",
      header: ({ table }) => (
        <input
          type="checkbox"
          checked={table.getIsAllPageRowsSelected()}
          onChange={() => table.toggleAllPageRowsSelected()}
        />
      ),
      cell: ({ row }) => (
        <input
          type="checkbox"
          checked={row.getIsSelected()}
          onChange={() => row.toggleSelected()}
        />
      ),
      size: "5%",
    },
   
    {
      header: "Task",
      accessorKey: "name",
      cell: ({ row }) => (
        <div>
          {row.original.name}
          <div style={{ fontSize: '12px', color: '#182C4E' , backgroundColor:'#F0E3FF',width:'fit-content' }} className="p-1 rounded">{row.original.name2}</div>
        </div>
      ),
    },
    {
      header: "SOP",
      accessorKey: "sop",
      cell: ({ cell, row }) => {
        return <div className=" bg-danger text-center rounded p-1 text-light " style={{fontSize:'12px'}}>{row.original.sop}</div>
      }
    },
    {
      header: "Assignee",
      accessorKey: "assignee",
      cell: ({ row }) => {
        const assigneeImage = `https://laser360clinic.com/wp-content/uploads/2020/08/user-image.jpg`; 
        return (
          <div className="d-flex align-items-center">
            <img src={assigneeImage} alt={row.original.assignee} style={{ width: '30px', height: '30px', marginRight: '10px' }} />
            {row.original.assignee}
          </div>
        );
      }
    },
    {
      header: "Due Date",
      accessorKey: "dueDate",
    },
    {
      header: "Priority",
      accessorKey: "priority",
      cell: ({ row }) => {
        const priority = row.original.priority;
        const iconSrc = priority === "High" ? "/task-high.svg" : priority === "Medium" ? "/task-medium.svg" : "/task-low.svg";
        return (
          <div className="d-flex align-items-center">
            <img src={iconSrc} alt={priority} style={{ width: '16px', height: '16px', marginRight: '15px' }} />
            {priority}
          </div>
        );
      },
    },
    {
      header: "Actions",
      cell: ({ row }) => {
        return (
          <div style={{ position: 'relative' }}>
            <FiMoreHorizontal 
              className="three-dot-menu" 
              onClick={(e) => {
                e.stopPropagation();
                setSelectedRow(selectedRow === row.index ? null : row.index);
              }}
              style={{ cursor: 'pointer' }}
            />
            {selectedRow === row.index && (
              <div className="action-menu">
              
                
                <button 
                  className="menu-item"
                  onClick={(e) => {
                    e.stopPropagation();
                   handleTaskEdit();
                  }}
                >
                  <PencilLine  size={16} />
                  <span>Edit</span>
                </button>
                <button 
                  className="menu-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMenuOption('publish', row.original);
                  }}
                >
             <img src="/publish.svg" alt="Publish" width={16} height={16} />

                  <span>Duplicate</span>
                </button>
                
                <button 
                  className="menu-item delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMenuOption('delete', row.original);
                  }}
                >
                  <Trash2 size={16} />
                  <span>Delete</span>
                </button>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const graphData = {
    name: "Root",
    value: 1000,
    children: [
      {
        name: "SEO",
        value: 200,
        children: [
          { name: "Customers", value: 70 },
          { name: "Products", value: 50 },
          { name: "Forms", value: 30 }
        ]
      },
      {
        name: "Email Marketing",
        value: 180,
        children: [
          { name: "SEO", value: 40 },
          { name: "General", value: 50 },
          { name: "Forms", value: 40 }
        ]
      },
      {
        name: "Strategy",
        value: 250,
        children: [
          { name: "Customers", value: 60 },
          { name: "Forms", value: 40 },
          { name: "SEO", value: 30 },
          { name: "UI/UX", value: 35 },
          { name: "Products", value: 45 }
        ]
      },
      {
        name: "Marketplace",
        value: 200,
        children: [
          { name: "Customers", value: 80 },
          { name: "Forms", value: 50 },
          { name: "SEO", value: 40 }
        ]
      },
      {
        name: "Content",
        value: 150,
        children: [
          { name: "Customers", value: 60 },
          { name: "Products", value: 50 }
        ]
      },
      {
        name: "Social",
        value: 120,
        children: [
          { name: "Customers", value: 50 },
          { name: "Forms", value: 40 }
        ]
      }
    ]
  };

  const handleTaskSubmit = (taskData) => {
    setTasks([...tasks, taskData]);
    setIsDrawerOpen(false);
  };
const handleTaskEdit =()=>{
  setIsEditing(true);
  setIsDrawerOpen(true);
}
const handleClose = () => {
  setIsDrawerOpen(false);
  setIsEditing(false);
};
  return (
    <div className="strategy-container ">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="dropdown-wrapper">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="strategy-dropdown-btn d-flex align-items-center"
            >
              <span className="me-2 task-title">All Task</span>
              <ChevronDown
                className={`chevron-icon ${isDropdownOpen ? "rotate" : ""}`}
              />
            </button>

            {isDropdownOpen && (
              <div className="dropdown-menu show">
                <a href="#" className="dropdown-item">Size</a>
                <a href="#" className="dropdown-item">Strategy</a>
                <a href="#" className="dropdown-item">SEO</a>
                <a href="#" className="dropdown-item">Content</a>
                <a href="#" className="dropdown-item">Influencer</a>
                <a href="#" className="dropdown-item">Marketplace</a>
                <a href="#" className="dropdown-item">Email Marketing</a>
              </div>
            )}
          </div>
          <p className="strategy-subtitle">
          Efficiently manage tasks across your workflows from a single view.
          </p>
          <p className="playbook">
            <Award size={15} /> Playbook <MoveUpRight size={10} />
          </p>
        </div>

        {tasks.length > 0 && (
          <button 
            onClick={() => setIsDrawerOpen(true)}
            className="px-4 py-2 btn btn-create"
          >
            <Plus size={20} />
            Add Task
          </button>
        )}
      </div>

      {tasks.length === 0 ? (
        <div className="empty-state-container">
          <div className="empty-state-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="4" y="4" width="16" height="16" rx="2" strokeWidth="2" />
              <path d="M4 8h16" strokeWidth="2" />
              <path d="M8 4v4" strokeWidth="2" />
              <path d="M16 4v4" strokeWidth="2" />
            </svg>
          </div>
          <p className="empty-state-text">No task created</p>
          <button className="btn btn-create" onClick={() => setIsDrawerOpen(true)}>
            <span>+</span>
            <span>Create New Task</span>
          </button>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow-sm">
          <ReusableTable
            columns={columns}
            data={tasks}
            graphData={graphData}
            onSearch={handleSearch}
            onDelete={handleDelete}
            onDuplicate={handleDuplicate}
          />
        </div>
      )}

      <AiChat />
      <TaskDrawer 
        isOpen={isDrawerOpen} 
        onClose={() => handleClose()}
        onSubmit={handleTaskSubmit}
        isEdit={isEditing}
      />
    </div>
  );
};

export default Tasks;